module.exports = __webpack_public_path__ + "media/free-trial/success-feedback-9d2f2999.svg";